import type { ReactNode } from "react";
import { useState } from "react";
import { useIsomorphicLayoutEffect } from "../hooks/layout-effect";

let hasMountedInClient = false;

/**
 * utility component that defers rendering of the children until the client is
 * executed in the browser.
 */
export function NoSSR(props: {
  children: ReactNode | ReactNode[];
}): React.JSX.Element | null {
  const [isClientSide, setClientSide] = useState(hasMountedInClient);

  useIsomorphicLayoutEffect(() => {
    setClientSide(true);

    // let future mounted components render instantly once we know we're
    // running in a clientside application life cycle
    hasMountedInClient = true;
  }, []);

  return isClientSide ? <>{props.children}</> : null;
}
